import Image from "next/image"
import { useAmp } from "next/amp"
import { AmpImage } from "@lib/amp"

import type { Author } from "@serializers/article"

interface ArticleAuthorProps {
  author: Author
}

export function ArticleAuthor(props: ArticleAuthorProps) {
  const { author } = props
  const isAmp = useAmp()

  return (
    <div className="container pt-6 flex items-center space-x-4 tablet:pt-8">
      {isAmp ? (
        <AmpImage width={68} height={68} layout="fixed" src={author.image} />
      ) : (
        <Image
          src={author.image}
          width={68}
          height={68}
          className="rounded-full"
          priority={true}
          unoptimized={true}
        />
      )}
      <p className="text-lg tracking-[1.5px] uppercase m-0">{author.name}</p>
    </div>
  )
}
